import React, { useState } from 'react';
import { Card } from '../components/ui/card';
import { Button } from '../components/ui/button';
import BirdAvatarOption, { AVATAR_OPTIONS } from '../components/BirdAvatarPreview';
import { Check } from 'lucide-react';

const AvatarPreviewPage = () => {
  const [selectedIds, setSelectedIds] = useState([]);

  const toggleSelection = (id) => {
    if (selectedIds.includes(id)) {
      setSelectedIds(selectedIds.filter(i => i !== id));
    } else {
      if (selectedIds.length < 10) {
        setSelectedIds([...selectedIds, id]);
      }
    }
  };

  const getSelectionNumber = (id) => {
    const index = selectedIds.indexOf(id);
    return index !== -1 ? index + 1 : null;
  };

  return (
    <div className="min-h-screen bg-background p-8">
      <div className="container mx-auto max-w-6xl">
        <div className="text-center mb-8">
          <h1 className="text-4xl font-heading font-bold mb-2">
            Choose Your Favorite <span className="text-gradient-primary">10 Avatars</span>
          </h1>
          <p className="text-lg text-muted-foreground mb-4">
            Click on the birds you like best! Selected: {selectedIds.length}/10
          </p>
          {selectedIds.length === 10 && (
            <div className="inline-block px-4 py-2 rounded-lg bg-green-500/20 border border-green-500/50 text-green-500 font-semibold">
              ✓ Perfect! You've selected 10 avatars
            </div>
          )}
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 mb-8">
          {AVATAR_OPTIONS.map((option) => {
            const isSelected = selectedIds.includes(option.id);
            const selectionNumber = getSelectionNumber(option.id);
            
            return (
              <Card
                key={option.id}
                onClick={() => toggleSelection(option.id)}
                className={`p-4 cursor-pointer transition-all relative ${
                  isSelected
                    ? 'border-primary bg-primary/10 shadow-lg scale-105'
                    : 'border-border hover:border-primary/50 hover:scale-102'
                }`}
              >
                {isSelected && (
                  <div className="absolute top-2 right-2 w-6 h-6 rounded-full bg-primary text-primary-foreground flex items-center justify-center font-bold text-xs">
                    {selectionNumber}
                  </div>
                )}
                <BirdAvatarOption option={option} size={80} />
              </Card>
            );
          })}
        </div>

        <div className="text-center">
          <Card className="p-6 inline-block bg-gradient-card">
            <h3 className="font-semibold mb-2">Selected Avatars Order:</h3>
            <div className="flex flex-wrap gap-2 justify-center">
              {selectedIds.length === 0 ? (
                <p className="text-muted-foreground text-sm">No avatars selected yet</p>
              ) : (
                selectedIds.map((id, index) => {
                  const option = AVATAR_OPTIONS.find(o => o.id === id);
                  return (
                    <div key={id} className="text-sm px-3 py-1 rounded-full bg-primary/20 text-primary font-medium">
                      {index + 1}. {option.name}
                    </div>
                  );
                })
              )}
            </div>
            {selectedIds.length === 10 && (
              <div className="mt-4">
                <p className="text-xs text-muted-foreground mb-2">
                  Copy this list and share it with me!
                </p>
                <code className="block p-2 bg-muted rounded text-xs">
                  {selectedIds.join(', ')}
                </code>
              </div>
            )}
          </Card>
        </div>
      </div>
    </div>
  );
};

export default AvatarPreviewPage;
